import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle, Zap, Shield, Globe, Clock, Users } from 'lucide-react';

const FeaturesPage = () => {
  const features = [
    {
      icon: CheckCircle,
      title: 'Task Management',
      description: 'Create, edit, and delete tasks with ease. Set priorities, due dates, and track progress.'
    },
    {
      icon: Users,
      title: 'User Profiles',
      description: 'Personalized dashboards and profiles for each user with secure authentication.'
    },
    {
      icon: Zap,
      title: 'Lightning Fast',
      description: 'Built on Cloudflare edge network for sub-50ms response times globally.'
    },
    {
      icon: Shield,
      title: 'Enterprise Security',
      description: 'JWT authentication, encrypted passwords, and secure data storage.'
    },
    {
      icon: Globe,
      title: 'Works Everywhere',
      description: 'Access your tasks from any device with our responsive web application.'
    },
    {
      icon: Clock,
      title: 'Real-time Updates',
      description: 'Changes sync instantly across all your devices without page refresh.'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-white">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center text-primary-600 hover:text-primary-700 mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Features</h1>
          <p className="text-xl text-gray-600 mb-12">
            Everything you need to stay organized and productive
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
              >
                <feature.icon className="w-12 h-12 text-primary-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </motion.div>
            ))}
          </div>

          <div className="mt-12 bg-primary-600 text-white rounded-lg p-8 text-center">
            <h2 className="text-2xl font-bold mb-4">Ready to Get Started?</h2>
            <p className="mb-6">Join TaskFlow today and transform how you manage your tasks.</p>
            <Link to="/register" className="bg-white text-primary-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors inline-block">
              Sign Up Free
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FeaturesPage;
